import { BackgroundImageContainer } from './styled';

type Props = {
  imageUrl: string;
  opacity: string;
  blur?: string;
};

export const BackgroundImage = ({
  imageUrl,
  opacity = '50%',
  blur = '0px',
}: Props) => {
  return (
    <BackgroundImageContainer
      data-testid="tile-background-image"
      imageUrl={imageUrl}
      opacity={opacity}
      blur={blur}
    />
  );
};
